import type { NotifyCandidateMethod } from 'clients/CampaignsClient/CampaignsClient.types';
import type { ContactCandidateData } from '../useContactCandidateMutation.types';

export const isCallData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'call'> => {
  return sendMethod === 'call';
};

export const isWhatsappData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'whatsapp'> => {
  return sendMethod === 'whatsapp';
};

export const isLinkedinData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'linkedin'> => {
  return sendMethod === 'linkedin';
};

export const isLinkedinInMailData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'linkedin_inmail'> => {
  return sendMethod === 'linkedin_inmail';
};

export const isEmailData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'email'> => {
  return sendMethod === 'email';
};

export const isIndeedData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'indeed'> => {
  return sendMethod === 'indeed';
};

export const isWerknlData = <T extends NotifyCandidateMethod>(
  sendMethod: T,
  params: ContactCandidateData<any> | undefined,
): params is ContactCandidateData<'werknl'> => {
  return sendMethod === 'werknl';
};
